import {
	useCallback,
	useEffect,
	useState,
} from 'react';

import bgSrcWebM from '../assets/videos/petalwipehd_pr1.webm';
import bgSrcMov from '../assets/videos/petalwipehd_alpha-HVEC_Low.mov';
import GlobalEvents from '../GlobalEvents';

let mounted = false;
let canPlayThrough = false;

const videoElement = document.createElement('video');

videoElement.playsInline = true;
videoElement.muted = true;
videoElement.preload = "auto";

let timeoutHandler = null;

videoElement.onended = () => {
	clearTimeout(timeoutHandler);
	if(mounted){
		mounted = false;
		GlobalEvents.emit('TransitionVideo.onended');
	}
};
videoElement.oncanplaythrough = () => {
	canPlayThrough = true;
};

(async () => {
	let videoUrl = false;
	let mimeType = false;
	if(videoElement.canPlayType('video/quicktime; codecs="hvc1"') !== ""){
		mimeType = 'video/quicktime';
		videoUrl = bgSrcMov;
	}
	else if(videoElement.canPlayType('video/webm; codecs="vp9"') !== ""){
		mimeType = 'video/webm';
		videoUrl = bgSrcWebM;
	}

	if(videoUrl === false || mimeType === false){
		// Can't play anything. Short circuit.
		return;
	}

	const res = await fetch(videoUrl);
	const arrayBuffer = await res.arrayBuffer();
	const blob = new Blob([arrayBuffer], {
		type: mimeType
	});
	const url = URL.createObjectURL(blob);

	videoElement.src = url;
	videoElement.load();
	window.videoElement = videoElement;
})();

GlobalEvents.on('Link.play', () => {
	if(!canPlayThrough){
		setTimeout(() => GlobalEvents.emit('TransitionVideo.onended'), 1);
		return;
	}
	if(!mounted){
		mounted = true;
		videoElement.play();
		timeoutHandler = setTimeout(() => {
			mounted = false;
			GlobalEvents.emit('TransitionVideo.onended')
		}, 4000);
	}

});

export default function TransitionVideo() {
	const [visible, setVisible] = useState(false);

	const play = useCallback(() => {
		setVisible(true);
	}, []);

	const stop = useCallback(() => {
		setVisible(false);
	}, []);

	useEffect(() => {
		GlobalEvents.on('TransitionVideo.onended', stop);
		GlobalEvents.on('Link.play', play);

		return () => {
			GlobalEvents.removeListener('TransitionVideo.onended', stop);
			GlobalEvents.removeListener('Link.play', play);
		};
	}, [play, stop]);

	const onRef = useCallback((elm) => {
		elm.appendChild(videoElement);
	}, []);

	return <div className={`bg-vid ${visible ? 'show' : ''}`} ref={onRef}></div>;
}
